const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuidLike(value) {
  return UUID_RE.test(String(value ?? "").trim());
}

/**
 * Find a project row by id or project key (case-insensitive key).
 * @param {string} projectSlug
 * @param {Array<object>|null|undefined} list
 * @returns {string|null}
 */
export function findProjectDisplayNameInList(projectSlug, list) {
  if (!projectSlug || !Array.isArray(list) || !list.length) return null;
  const slug = String(projectSlug).trim();
  const slugLower = slug.toLowerCase();
  const byId = list.find((p) => String(p?.id ?? p?.projectId ?? "") === slug);
  if (byId) {
    const n = String(byId.projectName ?? byId.name ?? "").trim();
    if (n) return n;
  }
  const byKey = list.find(
    (p) =>
      String(p?.projectKey ?? p?.key ?? "")
        .trim()
        .toLowerCase() === slugLower
  );
  if (byKey) {
    const n = String(byKey.projectName ?? byKey.name ?? "").trim();
    if (n) return n;
  }
  return null;
}

/**
 * Resolve a human-readable project title for breadcrumbs and headers.
 * Never returns a raw UUID — use `fallbackLabel` when only an id is known.
 */
export function resolveProjectDisplayName(projectSlug, sources = {}) {
  const {
    workItemProjectName,
    workItemProject,
    workspaceProjectId,
    workspaceProjectName,
    fetchedProjectName,
    projectLists = [],
    fallbackLabel = "Project",
  } = sources;

  const fromWi = String(
    workItemProjectName ?? workItemProject?.name ?? workItemProject?.projectName ?? ""
  ).trim();
  if (fromWi) return fromWi;

  const fetched = String(fetchedProjectName ?? "").trim();
  if (fetched) return fetched;

  const slug = String(projectSlug ?? "").trim();
  if (slug && workspaceProjectId != null && String(workspaceProjectId).trim() === slug) {
    const ws = String(workspaceProjectName ?? "").trim();
    if (ws) return ws;
  }

  for (const list of projectLists) {
    const n = findProjectDisplayNameInList(slug, list);
    if (n) return n;
  }

  if (!slug) return fallbackLabel;
  if (isUuidLike(slug)) return fallbackLabel;
  return String(slug)
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
